"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectionContext = exports.SelectionContext = void 0;
var react_1 = __importStar(require("react"));
exports.SelectionContext = (0, react_1.createContext)({});
var useSelectionContext = function () { return (0, react_1.useContext)(exports.SelectionContext); };
exports.useSelectionContext = useSelectionContext;
var SelectionProvider = function (_a) {
    var onRowsSelection = _a.onRowsSelection, children = _a.children;
    var _b = (0, react_1.useState)({}), selectedRows = _b[0], setSelectedRows = _b[1];
    var isSelectedRow = (0, react_1.useCallback)(function (id) { return Object.prototype.hasOwnProperty.call(selectedRows, id); }, [selectedRows]);
    var onSelectedRow = (0, react_1.useCallback)(function (id) {
        var newSelectedRows = __assign({}, selectedRows);
        if (isSelectedRow(id)) {
            delete newSelectedRows[id];
        }
        else {
            newSelectedRows[id] = true;
        }
        setSelectedRows(newSelectedRows);
        onRowsSelection(newSelectedRows);
    }, [onRowsSelection, selectedRows, isSelectedRow, setSelectedRows]);
    var value = (0, react_1.useMemo)(function () { return ({
        selectedRows: selectedRows,
        isSelectedRow: isSelectedRow,
        onSelectedRow: onSelectedRow
    }); }, [
        selectedRows, isSelectedRow, onSelectedRow
    ]);
    return (react_1.default.createElement(exports.SelectionContext.Provider, { value: value }, children));
};
exports.default = SelectionProvider;
